import React, { useContext } from "react";
import "./MainTabs.scss";
import { Badge, Button, Input } from "antd";
import Swal from "sweetalert2";
import { FilterIconButton, SearchIconInput } from "../../../assets/icons";
import { InterviewsContext } from "../data";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";
const FilterComponent = () => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const {
    onChange,
    activeFilters,
    setOpenFilters,
    setActiveFilters,
    defaultSwalProperties,
  } = useContext(InterviewsContext);

  return (
    <div className="kanbanFilters">
      <Input
        placeholder="Kerko kandidatin..."
        className="inputSearchFilter"
        value={activeFilters?.kandidati}
        onChange={(event) => onChange(event.target.value, "kandidati")}
        prefix={<SearchIconInput fill={isDarkMode ? "#e6e6e6" : "#323338"} />}
      />
      <Badge
        size="medium"
        color="#20AC9D"
        count={
          !Object.keys(activeFilters)?.length
            ? null
            : Object.keys(activeFilters)?.length
        }
      >
        <MondayButton
          onClick={() => setOpenFilters(true)}
          className="mondayButtonBlue"
        >
          Filtroni
        </MondayButton>
      </Badge>
      {Object.keys(activeFilters)?.length > 0 && (
        <MondayButton
          className="mondayButtonRed"
          hasIcon={true}
          Icon={<FilterIconButton />}
          onClick={() => {
            setActiveFilters({});
            Swal.mixin({
              ...defaultSwalProperties,
            }).fire({
              icon: "info",
              title: "Te gjitha filtrat u pastruan!",
            });
          }}
        />
      )}
    </div>
  );
};

export default FilterComponent;
